export default __webpack_public_path__ + "static/media/app-install-icon.71e64f11.webp";